/**
 * Estado do Docs que vale fora da tela (F5): o documento aberto (fica guardado ao
 * ir para outra tela e voltar) e o "link" de documento usado no chat.
 * Este arquivo não importa o editor: a casca e o chat o usam sem carregar o Lexical.
 */
import { createSignal } from 'solid-js'

const [docAberto, setDocAberto] = createSignal<string | null>(null)
export { docAberto, setDocAberto }

export const novoId = () => crypto.randomUUID()

/** Documento citado numa mensagem do chat: [[doc:<id>|<título>]] */
export const LINK_DOC = /\[\[doc:([A-Za-z0-9_-]{8,64})\|([^\]\n]{1,200})\]\]/
export const linkDoc = (id: string, titulo: string) => `[[doc:${id}|${titulo.replace(/[\]|\n]/g, ' ').trim()}]]`

/** Pede à casca para abrir o Docs neste documento (clique no link do chat). */
export function abrirDoc(id: string): void {
  window.dispatchEvent(new CustomEvent('werc:abrir-doc', { detail: id }))
}
